import { DataGridPremium, plPL, GridToolbar } from '@mui/x-data-grid-premium';
import { styled } from '@mui/system';
import Switch from '../common/GreenSwitch';
import FormControl from './FormControl';
import CancelIcon from './RedCancelIcon';
import colors from '../../assets/colors';

const StyledDataGrid = styled(DataGridPremium, {
  shouldForwardProp: (prop) => prop !== 'bordered',
})(({ bordered }) => ({
  ...(bordered && {
    '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
      borderRight: `2px solid ${colors.white}`,
    },
    '& .MuiDataGrid-columnHeader:last-child, .MuiDataGrid-cell:last-child': {
      borderRight: `0px`,
    },
    '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
      borderBottom: `2px solid ${colors.white}`,
    },
  }),
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      backgroundColor: 'rgba(245, 245, 245, 1)',
      '&:nth-of-type(2n)': {
        backgroundColor: 'rgba(224, 224, 224, 1)',
      },
    },
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: colors.agroweGreen,
    color: 'rgba(255,255,255,1)',
    fontSize: 16,
    borderBottom: 2,
    borderColor: colors.white,
  },
  '& .MuiDataGrid-iconSeparator': {
    color: colors.agroweGreen,
  },
  '& .MuiDataGrid-columnHeaderCheckbox': {
    '& .MuiCheckbox-root': {
      '&:not(.Mui-checked)': {
        color: 'rgba(255,255,255,1)',
      },
    },
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    textOverflow: 'clip',
    whiteSpace: 'break-spaces',
    lineHeight: 1,
  },

  '& .MuiDataGrid-sortIcon': {
    color: 'rgba(255,255,255,1)',
  },
  '& .MuiDataGrid-menuIconButton': {
    color: 'rgba(255,255,255,1)',
  },
  '& .MuiDataGrid-filterIcon': {
    color: 'rgba(255,255,255,1)',
  },
  '& .MuiDataGrid-toolbarContainer': {
    '& .MuiButton-root': {
      '&:enabled': {
        color: colors.agroweGreen,
        fontSize: 20,
        fontWeight: 600,
      },
    },
  },
  '& .MuiTablePagination-actions': {
    '& .MuiButtonBase-root': {
      '&:enabled': {
        color: colors.agroweGreen,
      },
    },
  },
}));

const GridStyle = {
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      backgroundColor: 'rgba(245, 245, 245, 1)',
      '&:nth-of-type(2n)': {
        backgroundColor: 'rgba(224, 224, 224, 1)',
      },
    },
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: colors.agroweGreen,
    color: 'rgba(255,255,255,1)',
    fontSize: 16,
    borderBottom: 2,
    borderColor: colors.white,
  },
  '& .MuiDataGrid-columnHeaderCheckbox': {
    '& .MuiCheckbox-root': {
      '&:not(.Mui-checked)': {
        color: 'rgba(255,255,255,1)',
      },
    },
  },
  '& .MuiDataGrid-columnHeaderTitle': {},

  '& .MuiDataGrid-sortIcon': {
    color: 'rgba(255,255,255,1)',
  },
  '& .MuiDataGrid-menuIconButton': {
    color: 'rgba(255,255,255,1)',
  },
  '& .MuiDataGrid-filterIcon': {
    color: 'rgba(255,255,255,1)',
  },
  '& .MuiDataGrid-toolbarContainer': {
    '& .MuiButton-root': {
      textTransform: 'none',
      '&:enabled': {
        color: colors.agroweGreen,
        fontSize: 20,
        fontWeight: 600,
      },
    },
  },
  '& .MuiTablePagination-actions': {
    '& .MuiButtonBase-root': {
      '&:enabled': {
        color: colors.agroweGreen,
      },
    },
  },
};

const SDataGrid = (props) => (
  <StyledDataGrid
    disableSelectionOnClick
    localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
    components={
      props.toolbar
        ? {
            Toolbar: GridToolbar,
            BaseSwitch: Switch,
            BaseFormControl: FormControl,
            FilterPanelDeleteIcon: CancelIcon,
          }
        : {
            BaseSwitch: Switch,
            BaseFormControl: FormControl,
            FilterPanelDeleteIcon: CancelIcon,
          }
    }
    sx={{ GridStyle }}
    componentsProps={{
      filterPanel: {
        sx: {
          '& .MuiDataGrid-filterFormDeleteIcon': {
            justifyContent: 'center',
            marginRight: 2,
          },
          '& .MuiDataGrid-filterFormColumnInput': {
            border: 1,
            borderRadius: 1,
            marginRight: 2,
            padding: 1,
            minWidth: 150,
            '& .MuiFormLabel-root': {
              marginTop: 1,
              marginLeft: 1,
            },
          },
          '& .MuiDataGrid-filterFormOperatorInput': {
            border: 1,
            borderRadius: 1,
            marginRight: 2,
            padding: 1,
            minWidth: 150,
            '& .MuiFormLabel-root': {
              marginTop: 1,
              marginLeft: 1,
            },
          },
          '& .MuiDataGrid-filterFormValueInput': {
            border: 1,
            borderRadius: 1,
            padding: 1,
            minWidth: 150,
          },
        },
      },
      filterPanelDeleteIcon: { style: { color: 'red' } },
      columnsPanel: {
        sx: {
          '& .MuiFormControl-root': {
            border: 1,
            borderRadius: 1,
            padding: 1,
          },
          '& .MuiInputLabel-root': {
            marginLeft: 1,
          },
          '& label.Mui-focused': {
            color: colors.agroweGreen,
          },
          '& .MuiInput-underline': {
            borderBottomColor: colors.agroweGreen,
          },
          '& .MuiInput-underline:hover:before': {
            borderBottomColor: 'rgba(17, 131, 82, 0.5)',
          },
          '& .MuiInput-underline:after': {
            borderBottomColor: colors.agroweGreen,
          },
          '& .MuiButton-root': {
            textTransform: 'none',
          },
        },
      },
    }}
    {...props}
  />
);

export default SDataGrid;
